import { useTranslation } from "react-i18next";
import { useDisclosure } from "@mantine/hooks";
import { CampaignQueryDataType } from "src/hooks/campaigns";

import { Section } from "../section";
import { AssignmentOutcomeDetail } from "./detail";

export interface AssignmentOutcomeProps {
    campaign: CampaignQueryDataType;
}

export const AssignmentOutcome = ({ campaign }: AssignmentOutcomeProps) => {
    const { t } = useTranslation(["common"]);

    const [isCollapsed, { toggle: toggleCollapse }] = useDisclosure(false);

    return (
        <Section title={t("campaign_outcome")} isCollapsed={isCollapsed} onClick={toggleCollapse}>
            <AssignmentOutcomeDetail campaign={campaign} />
        </Section>
    );
};
